// extracted by mini-css-extract-plugin
module.exports = {"brandsList":"BrandsUnderline_brandsList__3ex9M","brandsListUnderline":"BrandsUnderline_brandsListUnderline__BbqKF"};